const banSites = {
  'YSB 88': null,
};

export function filterBanedSites(odds, selectedTab) {
  let targets = [];
  odds.international_additional.map((odd) => {
    if (odd.marketType === selectedTab && !banSites.hasOwnProperty(odd.oddsSite)) targets.push(odd);
  });
  odds.international_basic.map((odd) => {
    if (odd.marketType === selectedTab && !banSites.hasOwnProperty(odd.oddsSite)) targets.push(odd);
  });
  odds.domestic.map((odd) => {
    if (odd.marketType === selectedTab && !banSites.hasOwnProperty(odd.oddsSite)) targets.push(odd);
  });
  return targets;
}

export const siteInfo = {
  SBOBET: {
    name: 'SBOBET',
    url: 'https://www.sbobet.com',
  },
  Bet365: {
    name: 'BET365',
    url: 'https://www.bet365.com',
  },
  '1xBet': {
    name: 'XBET',
    url: 'https://1xbet.com',
  },
  '10Bet': {
    name: 'TENBET',
    url: 'https://www.10bet.com',
  },
  Dafabet: {
    name: 'DAFABET',
    url: 'https://www.dafabet.com',
  },
  'William Hill': {
    name: 'WILLIAM',
    url: 'https://www.williamhill.com',
  },
  BETMAN: {
    name: 'BETMAN',
    url: 'https://www.betman.co.kr',
  },
  Alphabet: {
    name: 'ALPHABET',
    url: 'https://www.alphabetapp.com.au',
  },
  '10x10bet': {
    name: 'X10BET',
    url: 'https://www.10x10bet.com',
  },
  'YSB 88': {
    name: 'YSB88',
    url: '',
  },
  Macauslot: {
    name: 'MACAUSLOT',
    url: 'https://www.macauslot.com',
  },
  Ladbrokes: {
    name: 'LADBROKES',
    url: 'https://www.ladbrokes.com',
  },
  Mansion88: {
    name: 'MANSION88',
    url: 'https://www.m88.com',
  },
  '12BET': {
    name: 'BET12',
    url: 'https://www.12bet.com',
  },
  'Victor Chandler': {
    name: 'VICTORCHANDLER',
    url: 'https://www.betvictor.com',
  },
  '188Bet': {
    name: 'BET188',
    url: 'https://www.188bet.com',
  },
};
